import { Pagination, Mousewheel, Navigation } from 'swiper';

import { Slider } from './slider';
import { matchMedia } from '../utility';

class InformationListSlider extends Slider {
  init() {
    super.init();
  }
}

export const informationListSlider = () => {
  const containers = document.querySelectorAll('.js-slider-information');
  containers.forEach((container) => {
    const parameters = {
      modules: [Pagination, Mousewheel, Navigation],
      slidesPerView: 1,
      loop: true,
      speed: 1000,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: container.querySelector('.swiper-pagination'),
        clickable: true,
      },
    };

    const informationListSliderInstance = new InformationListSlider(container, parameters);
    const swiperNav = document.querySelector('.js-slider-information .c-swiper__nav');
    const informationList = document.querySelectorAll(
      '.js-slider-information .p-informationList__item',
    );

    matchMedia('md').addEventListener('change', () => {
      const isMobile = !matchMedia('md').matches;
      if (isMobile) {
        informationListSliderInstance.active();
      } else {
        informationListSliderInstance.inactive();
      }
    });

    matchMedia('md').addEventListener('change', () => {
      const isMobile = !matchMedia('md').matches;
      if (isMobile && informationList.length > 1) {
        swiperNav?.classList.add('is-show');
      } else {
        swiperNav?.classList.remove('is-show');
      }
    });

    const isDesktop = matchMedia('md').matches;
    informationListSliderInstance.init();
    if (isDesktop) {
      informationListSliderInstance.inactive();
    }

    if (!isDesktop && informationList.length > 1) {
      swiperNav?.classList.add('is-show');
    }
  });
};
